import { createContext, useContext } from 'react';
import type { TreeViewContextData } from './types';

const defaultState = [] as string[];
const defaultSetter = (() => {}) as React.Dispatch<
  React.SetStateAction<string[]>
>;

const TreeViewStateContext = createContext<string[]>(defaultState);
const TreeViewSettersContext =
  createContext<React.Dispatch<React.SetStateAction<string[]>>>(defaultSetter);

export const TreeViewStateContextProvider = TreeViewStateContext.Provider;
export const TreeViewSettersContextProvider = TreeViewSettersContext.Provider;

/** Subscribe only to selectedValues. Re-renders when selection changes. */
export const useTreeViewState = () => useContext(TreeViewStateContext);

/** Subscribe only to setSelectedValues (stable ref). Does not re-render when selectedValues changes. */
export const useTreeViewSetters = () => useContext(TreeViewSettersContext);

/** Full context: both selectedValues and setSelectedValues. Re-renders when selectedValues changes. */
export const useTreeViewContext = (): TreeViewContextData => ({
  selectedValues: useTreeViewState(),
  setSelectedValues: useTreeViewSetters(),
});
